import { IAppearance } from "../application-settings/interfaces";

export interface IEmailTemplate {
  id: string;
  licenseID: number;
  createdAt: Date;
  createdBy: string;
  createdByType: string;
  updatedAt: Date;
  updatedBy: string;
  updatedByType: string;
  name: string;
  type?: "html" | "visual";
  content: {
    text: string;
    html: string;
    appearance?: IAppearance;
  };
}

export enum EmailTemplateTypeEnum {
  HTML = "html",
  VISUAL = "visual",
}

export interface IPreviewEmailTemplatePayload {
  content: {
    text: string;
    html: string;
  };
}
